/**
 * Microsite configuration for vendors
 * @todo make it configurable on databases
 */
export const micrositeVendorsConfig = {
  taptap: {
    alt: "Taptap",
    accent: "",
    micrositeFooter: {
      image: "../assets/collaboration-taptap.svg",
      width: 175,
      baseColor: "dark",
    },
    micrositeFeatures: {
      microsite_component_contact: true,
    },
    qrcode: {
      image: "../assets/taptap-square.svg",
      width: 0.35,
      margin: 30,
    },
  },
  mitrabl: {
    alt: "Mitra Bukalapak",
    accent: "#eb4a4b",
    micrositeFooter: {
      image: "../assets/collab_mitrabl.png",
      width: 280,
      baseColor: "dark",
    },
    micrositeFeatures: {
      microsite_component_contact: true,
    },
  },
};

export type QRVendor = {
  image: string;
  width: number;
  margin: number;
};
